import React, { useMemo } from 'react';

import { useAudioContext } from '../../context/AudioContext';
import { useDetailViewContext } from '../../context/DetailViewContext';
import { useNavigationContext } from '../../context/NavigationContext';

import FocusPoints from '../../data/FocusPoints';
import { SectionIDs } from '../../data/Sections';

import useWindowSize from '../../hooks/useWindowSize';
import Menu from './Menu';

import { ReactComponent as MenuIcon } from '../../assets/images/icons/menu.svg';
import styles from './styles.module.scss';

interface IMenuButton {
  video?: HTMLVideoElement
}


function MenuButton({video}: IMenuButton): JSX.Element { 
  const {width} = useWindowSize();
  const {playAudio} = useAudioContext();
  const {activeDetailID, activeFocusID} = useDetailViewContext();
  const {activeSectionID, isMenuOpen, setIsMenuOpen} = useNavigationContext();

  const buttonColor = useMemo(
    () => {
      if(
        activeSectionID === SectionIDs.Science
        && (activeDetailID && width > 900 || activeFocusID !== FocusPoints.None)) {
        return 'light';
      } else {
        switch (activeSectionID) {
        case SectionIDs.Title:
        case SectionIDs.About:
          return 'light';
        default:
          return 'dark';
        }
      }
    },
    [activeSectionID, activeDetailID, activeFocusID, width],
  );

  return <>
    {isMenuOpen && <Menu hideMenu={() => setIsMenuOpen(false)} video={video}></Menu>} 
    <button
      data-theme={buttonColor}
      className={styles.menuButton}
      style={{display: isMenuOpen ? 'none' : 'block'}}
      onClick={() => {setIsMenuOpen(isMenuOpen => !isMenuOpen); playAudio('audioMenuOpenClose');}}
    >
      <MenuIcon />
    </button>
  </>;
}

export default React.memo(MenuButton);